import React from 'react';
import { numberToUSD } from 'helpers/currency';
import { PriceContainer } from 'components/CartItemList/styled';
import { ProductPrice } from 'components/ProductCard/styled';
import Strikethrough from 'components/Strikethrough';
import { Show } from 'components/Functional';

interface CartItemPriceProps {
  qty: number;
  price: number;
  baseDiscountAmount: number;
  isCartItemFetching: boolean;
  isCartTransparencyTestOn: boolean;
  isDetailPrice?: boolean;
  showPlus?: boolean;
}

const strikethroughPriceStyles = {
  fontSize: '16px',
  lineHeight: '16px',
  fontFamily: 'Crimson Text, Georgia, serif',
  fontWeight: '400'
};

export const CartItemPrice = ({
  price,
  qty,
  baseDiscountAmount,
  isCartItemFetching,
  isCartTransparencyTestOn,
  isDetailPrice,
  showPlus
}: CartItemPriceProps): JSX.Element => {
  return (
    <PriceContainer isCartTransparencyTestOn={isCartTransparencyTestOn} isDetailPrice={isDetailPrice}>
      <Show when={showPlus}>+</Show>
      <ProductPrice strikethrough={!!baseDiscountAmount && !isCartItemFetching} bold={isCartTransparencyTestOn}>
        {numberToUSD(price * qty)}
      </ProductPrice>
      {!!baseDiscountAmount && !isCartItemFetching && (
        <Strikethrough
          strikethroughPrice={price * qty - baseDiscountAmount}
          shouldDisplayPromoCode={false}
          style={strikethroughPriceStyles}
        />
      )}
    </PriceContainer>
  );
};
